// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_52-0";